export const translations = {
  user_account: {
    french: 'Mon compte',
    english: 'My account',
    spanish: 'Mi cuenta',
    german: 'Mein Konto',
  },
  terms: {
    french: "Conditions d'utilisation",
    english: 'Terms of use',
    spanish: 'Términos de uso',
    german: 'Nutzungsbedingungen',
  },
  privacy_policy: {
    french: 'Politique de confidentialité',
    english: 'Privacy Policy',
    spanish: 'Política de privacidad',
    german: 'Datenschutz-Bestimmungen',
  },
  premium_feature: {
    french: 'Développement en cours',
    english: 'Work in progress',
    spanish: 'Trabajo en progreso',
    german: 'Arbeit im Gange',
    // french: 'Fonctionnalité réservée aux comptes Premium',
    // english: 'Feature reserved for Premium accounts',
    // spanish: 'Función reservada para cuentas Premium',
    // german: 'Funktion für Premium-Konten reserviert',
  },
  account_updated: {
    french: 'Compte mis à jour avec succès !',
    english: 'Account updated successfully!',
    spanish: '¡Cuenta actualizada con éxito!',
    german: 'Konto erfolgreich aktualisiert!',
  },
  accept_terms: {
    french:
      'Lisez notre {privacyPolicyLink}.{br}Appuyez sur "Accepter et continuer" pour accepter les {termsOfServiceLink}.',
    english:
      'Read our {privacyPolicyLink}.{br}Tap "Agree and Continue" to accept the {termsOfServiceLink}.',
    spanish:
      'Lea nuestra {privacyPolicyLink}.{br}Toque "Aceptar y continuar" para aceptar los {termsOfServiceLink}.',
    german:
      'Lesen Sie unsere {privacyPolicyLink}.{br}Tippen Sie auf "Zustimmen und Fortfahren", um den {termsOfServiceLink} zuzustimmen.',
  },
  agree_and_continue: {
    french: 'Accepter et continuer',
    english: 'Agree and Continue',
    spanish: 'Aceptar y continuar',
    german: 'Zustimmen und Fortfahren',
  },
  logout: {
    french: 'Se déconnecter',
    english: 'Logout',
    spanish: 'Cerrar sesión',
    german: 'Abmelden',
  },
  login: {
    french: 'Se connecter',
    english: 'Login',
    spanish: 'Iniciar sesión',
    german: 'Anmelden',
  },
  langue: {
    french: 'Langue',
    english: 'Language',
    spanish: 'Idioma',
    german: 'Sprache',
  },
  email: {
    french: 'Email',
    english: 'Email',
    spanish: 'Correo electrónico',
    german: 'E-Mail',
  },
  name: {
    french: 'Nom',
    english: 'Name',
    spanish: 'Nombre',
    german: 'Name',
  },
  phone: {
    french: 'Téléphone',
    english: 'Phone',
    spanish: 'Teléfono',
    german: 'Telefon',
  },
  save: {
    french: 'Enregistrer',
    english: 'Save',
    spanish: 'Guardar',
    german: 'Speichern',
  },
  cancel: {
    french: 'Annuler',
    english: 'Cancel',
    spanish: 'Cancelar',
    german: 'Abbrechen',
  },
  home: {
    french: 'Accueil',
    english: 'Home',
    spanish: 'Inicio',
    german: 'Startseite',
  },
  french: {
    french: 'Français',
    english: 'Français',
    spanish: 'Français',
    german: 'Français',
  },
  english: {
    french: 'English',
    english: 'English',
    spanish: 'English',
    german: 'English',
  },
  spanish: {
    french: 'Español',
    english: 'Español',
    spanish: 'Español',
    german: 'Español',
  },
  german: {
    french: 'Deutsch',
    english: 'Deutsch',
    spanish: 'Deutsch',
    german: 'Deutsch',
  },
  enter_email: {
    french: 'Veuillez entrer votre email.',
    english: 'Please enter your email.',
    spanish: 'Por favor, introduzca su correo electrónico.',
    german: 'Bitte geben Sie Ihre E-Mail-Adresse.',
  },
  enter_identifier_below: {
    french: 'Entrez votre email professionnel',
    english: 'Enter your professional email',
    spanish: 'Introduzca su correo electrónico profesional',
    german: 'Geben Sie Ihre professionelle E-Mail-Adresse ein',
  },
  verification_code_message: {
    french: 'Un code de vérification a été envoyé à votre adresse email',
    english: 'A verification code has been sent to your email address',
    spanish: 'Se ha enviado un código de verificación a su dirección de correo electrónico',
    german: 'Ein Bestätigungscode wurde an Ihre E-Mail-Adresse gesendet',
  },
  verification_code_incorrect: {
    french: 'Code de vérification incorrect, veuillez réessayer.',
    english: 'Incorrect verification code, please try again.',
    spanish: 'Código de verificación incorrecto, por favor inténtelo de nuevo.',
    german: 'Falscher Bestätigungscode, bitte versuchen Sie es erneut.',
  },
  verification_code_correct: {
    french: 'Code de vérification correct.',
    english: 'Verification code correct.',
    spanish: 'Código de verificación correcto.',
    german: 'Bestätigungscode korrekt.',
  },
  send_new_code: {
    french: 'Un nouveau code de vérification a été envoyé.',
    english: 'A new verification code has been sent.',
    spanish: 'Se ha enviado un nuevo código de verificación.',
    german: 'Ein neuer Bestätigungscode wurde gesendet.',
  },
  verify_account: {
    french: 'Vérifiez votre compte',
    english: 'Verify your account',
    spanish: 'Verifique su cuenta',
    german: 'Überprüfen Sie Ihr Konto',
  },
  enter_the_6_digits_sent: {
    french: 'Entrez le code à 6 chiffres que vous avez reçu.',
    english: 'Enter the 6-digit code you received.',
    spanish: 'Ingrese el código de 6 dígitos que recibió.',
    german: 'Geben Sie den 6-stelligen Code ein, den Sie erhalten haben.',
  },
  verify: {
    french: 'Vérifier',
    english: 'Verify',
    spanish: 'Verificar',
    german: 'Überprüfen',
  },
  resend_code: {
    french: 'Envoyer à nouveau',
    english: 'Resend code',
    spanish: 'Reenviar código',
    german: 'Code erneut senden',
  },
  average_increase: {
    french: 'La moyenne des {word} par jour a augmenté de {number}% ce mois-ci.',
    english: 'The average of {word} per day increased by {number}% this month.',
    spanish: 'El promedio de {word} por día aumentó en {number}% este mes.',
    german: 'Der Durchschnitt von {word} pro Tag ist um {number}% gestiegen.',
  },
  average_decrease: {
    french: 'La moyenne des {word} par jour a diminué de {number}% ce mois-ci.',
    english: 'The average of {word} per day decreased by {number}% this month.',
    spanish: 'El promedio de {word} por día disminuyó en {number}% este mes.',
    german: 'Der Durchschnitt von {word} pro Tag ist um {number}% gesunken.',
  },
  average_stable: {
    french: 'La moyenne des {word} par jour est restée stable ce mois-ci.',
    english: 'The average of {word} per day remained stable this month.',
    spanish: 'El promedio de {word} por día se mantuvo estable este mes.',
    german: 'Der Durchschnitt von {word} pro Tag blieb in diesem Monat stabil.',
  },
  no_data_available: {
    french: 'Aucune donnée disponible',
    english: 'No data available',
    spanish: 'No hay datos disponibles',
    german: 'Keine Daten verfügbar',
  },
  no_door_found: {
    french: 'Aucune porte trouvée',
    english: 'No door found',
    spanish: 'No se encontró ninguna puerta',
    german: 'Keine Tür gefunden',
  },
  no_group_found: {
    french: 'Aucun groupe trouvé',
    english: 'No group found',
    spanish: 'No se encontró ningún grupo',
    german: 'Keine Gruppe gefunden',
  },
  no_collaborator_found: {
    french: 'Aucun collaborateur trouvé',
    english: 'No collaborator found',
    spanish: 'No se encontró ningún colaborador',
    german: 'Kein Mitarbeiter gefunden',
  },
  no_message_found: {
    french: 'Aucun message',
    english: 'No message',
    spanish: 'Sin mensaje',
    german: 'Keine Nachricht',
  },
  no_others_messages: {
    french: "Pas d'autres messages",
    english: 'No other messages',
    spanish: 'No hay otros mensajes',
    german: 'Keine anderen Nachrichten',
  },
  cycles: {
    french: 'cycles ',
    english: 'cycles ',
    spanish: 'ciclos ',
    german: 'Zyklen ',
  },
  anomalies: {
    french: 'Anomalies ',
    english: 'Anomalies ',
    spanish: 'Anomalías ',
    german: 'Anomalien ',
  },
  uses: {
    french: 'Usages ',
    english: 'Uses ',
    spanish: 'Usos ',
    german: 'Verwendungen ',
  },
  period: {
    french: 'période ',
    english: 'period ',
    spanish: 'período ',
    german: 'Zeitraum ',
  },
  schedule_alerts: {
    french: "Programmez à l'avances vos alertes de maintenance pour cette porte.",
    english: 'Schedule your maintenance alerts in advance for this door.',
    spanish: 'Programe sus alertas de mantenimiento con anticipación para esta puerta.',
    german: 'Planen Sie Ihre Wartungswarnungen im Voraus für diese Tür.',
  },
  alerts: {
    french: 'Alertes',
    english: 'Alerts',
    spanish: 'Alertas',
    german: 'Warnungen',
  },
  messages: {
    french: 'Messages',
    english: 'Messages',
    spanish: 'Mensajes',
    german: 'Nachrichten',
  },
  message: {
    french: 'Message',
    english: 'Message',
    spanish: 'Mensaje',
    german: 'Nachricht',
  },
  date_of_commission: {
    french: 'Date de mise en service :',
    english: 'Date of commissioning:',
    spanish: 'Fecha de puesta en servicio:',
    german: 'Inbetriebnahmedatum:',
  },
  no_date_of_commission: {
    french: 'Aucune date de mise en service',
    english: 'No date of commissioning',
    spanish: 'Sin fecha de puesta en servicio',
    german: 'Kein Inbetriebnahmedatum',
  },
  warranty_end_date: {
    french: 'Date de fin de garantie :',
    english: 'Warranty end date:',
    spanish: 'Fecha de fin de garantía:',
    german: 'Garantie-Enddatum:',
  },
  no_warranty_end_date: {
    french: 'Aucune date de fin de garantie',
    english: 'No warranty end date',
    spanish: 'Sin fecha de fin de garantía',
    german: 'Kein Garantie-Enddatum',
  },
  last_message: {
    french: 'Dernier message :',
    english: 'Last message:',
    spanish: 'Último mensaje:',
    german: 'Letzte Nachricht:',
  },
  no_last_message: {
    french: 'Aucun message',
    english: 'No message',
    spanish: 'Sin mensaje',
    german: 'Keine Nachricht',
  },
  days: {
    french: 'jours',
    english: 'days',
    spanish: 'días',
    german: 'Tage',
  },
  day: {
    french: 'Jour',
    english: 'Day',
    spanish: 'Día',
    german: 'Tag',
  },
  hour: {
    french: 'Heure',
    english: 'Hour',
    spanish: 'Hora',
    german: 'Stunde',
  },
  month: {
    french: 'Mois',
    english: 'Month',
    spanish: 'Mes',
    german: 'Monat',
  },
  breakdown: {
    french: 'Période',
    english: 'Breakdown',
    spanish: 'Desglose',
    german: 'Aufschlüsselung',
  },
  choose_door: {
    french: 'Choisir une porte',
    english: 'Choose a door',
    spanish: 'Elegir una puerta',
    german: 'Wählen Sie eine Tür',
  },
  start: {
    french: 'Début (UTC)',
    english: 'Start (UTC)',
    spanish: 'Inicio (UTC)',
    german: 'Anfang (UTC)',
  },
  end: {
    french: 'Fin (UTC)',
    english: 'End (UTC)',
    spanish: 'Fin (UTC)',
    german: 'Ende (UTC)',
  },

  receive_sms: {
    french: 'Recevoir un SMS si le nombre de {word} dépasse le seuil suivant :',
    english: 'Receive an SMS if the number of {word} exceeds the following threshold:',
    spanish: 'Recibir un SMS si el número de {word} supera el siguiente umbral:',
    german:
      'Erhalten Sie eine SMS, wenn die Anzahl der {word} den folgenden Schwellenwert überschreitet:',
  },

  cycles_day: {
    french: 'Cycles par jours',
    english: 'Cycles per days',
    spanish: 'Ciclos por días',
    german: 'Zyklen pro Tage',
  },
  anomaly_day: {
    french: 'Seuil anomalies par jours',
    english: 'Anomaly threshold per days',
    spanish: 'Umbral de anomalías por días',
    german: 'Anomalie-Schwellenwert pro Tag',
  },
  my_collaborators: {
    french: 'Mes collaborateurs',
    english: 'My collaborators',
    spanish: 'Mis colaboradores',
    german: 'Meine Mitarbeiter',
  },
  add_a_new_collaborator: {
    french: 'Ajouter un nouveau collaborateur',
    english: 'Add a new collaborator',
    spanish: 'Agregar un nuevo colaborador',
    german: 'Einen neuen Mitarbeiter hinzufügen',
  },
  collaborator_s_email: {
    french: 'Email du collaborateur',
    english: "Collaborator's email",
    spanish: 'Correo electrónico del colaborador',
    german: 'E-Mail des Mitarbeiters',
  },
  collaborator_s_name: {
    french: 'Nom du collaborateur',
    english: "Collaborator's name",
    spanish: 'Nombre del colaborador',
    german: 'Name des Mitarbeiters',
  },
  collaborator_s_phone: {
    french: 'Téléphone du collaborateur',
    english: "Collaborator's phone",
    spanish: 'Teléfono del colaborador',
    german: 'Telefon des Mitarbeiters',
  },
  confirmation_remove_collaborator: {
    french: 'Êtes-vous sûr de vouloir supprimer ce collaborateur ?',
    english: 'Are you sure you want to remove this collaborator?',
    spanish: '¿Está seguro de que desea eliminar a este colaborador?',
    german: 'Sind Sie sicher, dass Sie diesen Mitarbeiter entfernen möchten?',
  },
  remove: {
    french: 'Supprimer',
    english: 'Remove',
    spanish: 'Eliminar',
    german: 'Entfernen',
  },
  user_not_found: {
    french: 'Utilisateur non trouvé',
    english: 'User not found',
    spanish: 'Usuario no encontrado',
    german: 'Benutzer nicht gefunden',
  },
  generic_error: {
    french: 'Il y a eu une erreur, veuillez réessayer.',
    english: 'There was an error, please try again.',
    spanish: 'Hubo un error, por favor intente de nuevo.',
    german: 'Es gab einen Fehler, bitte versuchen Sie es erneut.',
  },
  account_successfully_verified: {
    french: 'Compte vérifié avec succès !',
    english: 'Account verified successfully!',
    spanish: '¡Cuenta verificada con éxito!',
    german: 'Konto erfolgreich verifiziert!',
  },
  error_fetching_doors: {
    french: 'Erreur lors de la récupération des portes :',
    english: 'Error fetching doors:',
    spanish: 'Error al obtener las puertas:',
    german: 'Fehler beim Abrufen der Türen:',
  },
  error_fetching_door: {
    french: 'Erreur lors de la récupération de la porte :',
    english: 'Error fetching door:',
    spanish: 'Error al obtener la puerta:',
    german: 'Fehler beim Abrufen der Tür:',
  },
  all_fields_required: {
    french: 'Tous les champs sont requis',
    english: 'All fields are required',
    spanish: 'Todos los campos son obligatorios',
    german: 'Alle Felder sind erforderlich',
  },
  door_width: {
    french: 'Largeur de la porte :',
    english: 'Door width:',
    spanish: 'Ancho de la puerta:',
    german: 'Türbreite:',
  },
  door_height: {
    french: 'Hauteur de la porte :',
    english: 'Door height:',
    spanish: 'Altura de la puerta:',
    german: 'Türhöhe:',
  },
  address: {
    french: 'Adresse :',
    english: 'Address:',
    spanish: 'Dirección:',
    german: 'Adresse:',
  },
  pagination_items_count: {
    french: '{itemCount} élément(s)',
    english: '{itemCount} item(s)',
    spanish: '{itemCount} elemento(s)',
    german: '{itemCount} Artikel',
  },
  // INFO: it was using too much space
  pagination_items_per_page: {
    french: '',
    english: '',
    spanish: '',
    german: '',
  },
  support: {
    french: 'Service après-vente',
    english: 'After-sales service',
    spanish: 'Servicio postventa',
    german: 'Kundendienst',
  },
  filter: {
    french: 'Filtres',
    english: 'Filters',
    spanish: 'Filtros',
    german: 'Filter',
  },
  doors_model: {
    french: 'Modèle de portes',
    english: 'Door models',
    spanish: 'Modelos de puertas',
    german: 'Türmodelle',
  },
  model: {
    french: 'Modèle :',
    english: 'Model:',
    spanish: 'Modelo:',
    german: 'Modell:',
  },
  commissioning_after: {
    french: 'Mise en service après le :',
    english: 'Commissioning after:',
    spanish: 'Puesta en servicio después del:',
    german: 'Inbetriebnahme nach:',
  },
  send_to_Maviflex: {
    french: 'Envoyer à Maviflex',
    english: 'Send to Maviflex',
    spanish: 'Enviar a Maviflex',
    german: 'An Maviflex senden',
  },
  resolve_anomaly: {
    french: `Résoudre l'anomalie`,
    english: 'Resolve anomaly',
    spanish: 'Restablecer anomalía',
    german: 'Anomalie zurücksetzen',
  },
  no_anomaly_to_resolve: {
    french: "Il n'y a pas d'anomalie à résoudre.",
    english: 'There is no anomaly to resolve.',
    spanish: 'No hay ninguna anomalía que restablecer.',
    german: 'Es gibt keine Anomalie zu zurücksetzen.',
  },
  anomaly_resolved_successfully: {
    french: "L'anomalie a été résolue avec succès !",
    english: 'Anomaly resolved successfully!',
    spanish: '¡Anomalía restablecida con éxito!',
    german: 'Anomalie erfolgreich zurückgesetzt!',
  },
  send: {
    french: 'Envoyer',
    english: 'Send',
    spanish: 'Enviar',
    german: 'Senden',
  },

  status: {
    french: 'Statut',
    english: 'Status',
    spanish: 'Estado',
    german: 'Status',
  },
  change_status: {
    french: 'Changer le statut',
    english: 'Change status',
    spanish: 'Cambiar estado',
    german: 'Status ändern',
  },
  alert_resolved: {
    french: 'Alerte résolue',
    english: 'Alert resolved',
    spanish: 'Alerta resuelta',
    german: 'Alarm behoben',
  },
  alert_to_watch: {
    french: 'Alerte à surveiller',
    english: 'Alert to watch',
    spanish: 'Alerta a vigilar',
    german: 'Alarm zu beobachten',
  },
  alert_blocking: {
    french: 'Alerte bloquante',
    english: 'Alert blocking',
    spanish: 'Alerta bloqueante',
    german: 'Alarm blockierend',
  },
  modify: {
    french: 'modifier',
    english: 'modify',
    spanish: 'modificar',
    german: 'ändern',
  },
  take_or_import_photo_video: {
    french: 'Prendre ou importer une photo ou une vidéo',
    english: 'Take or import a photo or video',
    spanish: 'Tomar o importar una foto o video',
    german: 'Foto oder Video aufnehmen oder importieren',
  },
  delete_account: {
    french: 'Supprimer le compte',
    english: 'Delete account',
    spanish: 'Eliminar cuenta',
    german: 'Konto löschen',
  },
  delete_account_warning: {
    french: 'Êtes-vous sûr de vouloir supprimer votre compte ?',
    english: 'Are you sure you want to delete your account?',
    spanish: '¿Está seguro de que desea eliminar su cuenta?',
    german: 'Sind Sie sicher, dass Sie Ihr Konto löschen möchten?',
  },
  yes: {
    french: 'Oui',
    english: 'Yes',
    spanish: 'Sí',
    german: 'Ja',
  },
  groups: {
    french: 'Groupes',
    english: 'Groups',
    spanish: 'Grupos',
    german: 'Gruppen',
  },
  doors: {
    french: 'Portes',
    english: 'Doors',
    spanish: 'Puertas',
    german: 'Türen',
  },
  no_door: {
    french: 'Aucune porte',
    english: 'No door',
    spanish: 'Sin puerta',
    german: 'Keine Tür',
  },
  one_door: {
    french: '1 porte',
    english: '1 door',
    spanish: '1 puerta',
    german: '1 Tür',
  },
  x_doors: {
    french: '{count} portes',
    english: '{count} doors',
    spanish: '{count} puertas',
    german: '{count} Türen',
  },
  search: {
    french: 'Recherche',
    english: 'Search',
    spanish: 'Buscar',
    german: 'Suche',
  },
  manufacture_year: {
    french: 'Année de fabrication :',
    english: 'Manufacture year:',
    spanish: 'Año de fabricación:',
    german: 'Baujahr:',
  },
  settings: {
    french: 'Paramètres',
    english: 'Settings',
    spanish: 'Configuración',
    german: 'Einstellungen',
  },
  notifications_settings: {
    french: 'Paramètres des notifications',
    english: 'Notifications settings',
    spanish: 'Configuración de notificaciones',
    german: 'Benachrichtigungseinstellungen',
  },
  sharing: {
    french: 'Partage',
    english: 'Sharing',
    spanish: 'Compartir',
    german: 'Teilen',
  },
  statistics: {
    french: 'Stats',
    english: 'Stats',
    spanish: 'Estadísticas',
    german: 'Statistiken',
  },
  info: {
    french: 'Info',
    english: 'Info',
    spanish: 'Info',
    german: 'Info',
  },
  details: {
    french: 'Détails',
    english: 'Details',
    spanish: 'Detalles',
    german: 'Details',
  },
  door_label_updated: {
    french: 'Le label de la porte a été mis à jour avec succès !',
    english: 'Door label updated successfully!',
    spanish: '¡Etiqueta de puerta actualizada con éxito!',
    german: 'Türschild erfolgreich aktualisiert!',
  },
  error_updating_door_label: {
    french: 'Erreur lors de la mise à jour du label de la porte, veuillez réessayer.',
    english: 'Error updating door label, please try again.',
    spanish: 'Error al actualizar la etiqueta de la puerta, por favor intente de nuevo.',
    german: 'Fehler beim Aktualisieren des Türschilds, bitte versuchen Sie es erneut.',
  },
  //
  // Door alert message translations
  //
  problem_brake_replay_at_shutdown: {
    french: 'Relecture sortie frein',
    english: 'Brake release at shutdown',
    spanish: 'Reproducción de liberación de freno al apagar',
    german: 'Bremsfreigabe beim Herunterfahren',
  },
  problem_brake_replay_at_shutdown_action: {
    french:
      'Sur la carte "Brake fault" à la coupure de courant alors message "normal".{new_line}Prévoir le remplacement de la carte si message "Brake fault" permanent.',
    english:
      'On the "Brake fault" board at power off then "normal" message.{new_line}Plan to replace the board if permanent "Brake fault" message.',
    spanish:
      'En la placa "Fallo de freno" al apagar la energía luego mensaje "normal".{new_line}Planificar el reemplazo de la placa si el mensaje "Fallo de freno" es permanente.',
    german:
      'Auf der "Bremsfehler"-Platine bei Stromausfall dann "normal"-Meldung.{new_line}Planen Sie den Austausch der Platine, wenn die Meldung "Bremsfehler" dauerhaft ist.',
  },
  detection_of_the_belt_breakage: {
    french: 'Analyse transmission',
    english: 'Belt breakage detection',
    spanish: 'Análisis de transmisión',
    german: 'Riemenbrucherkennung',
  },
  detection_of_the_belt_breakage_action: {
    french:
      'Sur la carte "Belt Issu".{new_line}Encrassement ou mauvais positionnement du codeur : Nettoyage, et repositionnement du codeur et de l\'aimant.{new_line}Patinage de la courroie: contrôle ou remplacement de la courroie (remplacement préventif tous les 250 000 cycles).{new_line}Rupture de la courroie : remplacement.',
    english:
      'On the "Belt Issu" board.{new_line}Soiling or misalignment of the encoder: Cleaning, and repositioning of the encoder and magnet.{new_line}Belt slippage: check or replacement of the belt (preventive replacement every 250,000 cycles).{new_line}Belt breakage: replacement.',
    spanish:
      'En la placa "Belt Issu".{new_line}Suciedad o desalineación del codificador: limpieza y reposicionamiento del codificador y el imán.{new_line}Deslizamiento de la correa: comprobación o reemplazo de la correa (reemplazo preventivo cada 250.000 ciclos).{new_line}Ruptura de la correa: reemplazo.',
    german:
      'Auf der "Belt Issu"-Platine.{new_line}Verschmutzung oder Fehlausrichtung des Encoders: Reinigung und Neupositionierung des Encoders und Magneten.{new_line}Riemenschlupf: Überprüfung oder Austausch des Riemens (präventiver Austausch alle 250.000 Zyklen).{new_line}Riemenbruch: Austausch.',
  },
  detection_of_the_duration_of_movement_too_long: {
    french: 'Gestion du temps de déplacement sur ouverture fermeture',
    english: 'Detection of the duration of movement too long',
    spanish: 'Gestión del tiempo de desplazamiento en apertura cierre',
    german: 'Erkennung der zu langen Bewegungsdauer',
  },
  detection_of_the_duration_of_movement_too_long_action: {
    french:
      'Sur la carte "Mvt Time Off".{new_line}Coincement du tablier lors de son déplacement.{new_line}Tension de la courroie.{new_line}Vérification du fonctionnement du frein.{new_line}Vérification des paramètres de vitesses.{new_line}Branchement moteur.',
    english:
      'On the "Mvt Time Off" board.{new_line}Jamming of the curtain during its movement.{new_line}Belt tension.{new_line}Check brake operation.{new_line}Check speed parameters.{new_line}Motor connection.',
    spanish:
      'En la placa "Mvt Time Off".{new_line}Atasco del tabique durante su movimiento.{new_line}Tensión de la correa.{new_line}Comprobación del funcionamiento del freno.{new_line}Comprobación de los parámetros de velocidad.{new_line}Conexión del motor.',
    german:
      'Auf der "Mvt Time Off"-Platine.{new_line}Blockierung des Vorhangs während seiner Bewegung.{new_line}Riemenspannung.{new_line}Überprüfung der Bremsfunktion.{new_line}Überprüfung der Geschwindigkeitsparameter.{new_line}Motoranschluss.',
  },
  incorrect_max_current_setting: {
    french: 'Reglage intensité max',
    english: 'Max current setting',
    spanish: 'Ajuste de corriente máxima',
    german: 'Maximale Stromeinstellung',
  },
  incorrect_max_current_setting_action: {
    french: 'Sur la carte "Current Set".{new_line}Réglage usine.',
    english: 'On the "Current Set" board.{new_line}Factory setting.',
    spanish: 'En la placa "Current Set".{new_line}Ajuste de fábrica.',
    german: 'Auf der "Current Set"-Platine.{new_line}Werkseinstellung.',
  },
  cell_test_erreur: {
    french: 'Autotest des cellules de sécurité',
    english: 'Self-test of safety cells',
    spanish: 'Autoprueba de las células de seguridad',
    german: 'Selbsttest der Sicherheitszellen',
  },
  cell_test_error_action: {
    french:
      'Sur la carte "Cell Test".{new_line}Nettoyage des sécurités.{new_line}Fonctionnement des sécurités ...{new_line}Voir écran cell diagnostic sur la carte électronique.{new_line}Cellule HS à remplacer.',
    english:
      'On the "Cell Test" board.{new_line}Cleaning of the safety devices.{new_line}Operation of the safety devices ...{new_line}See cell diagnostic screen on the electronic board.{new_line}Defective cell to be replaced.',
    spanish:
      'En la placa "Cell Test".{new_line}Limpieza de los dispositivos de seguridad.{new_line}Funcionamiento de los dispositivos de seguridad ...{new_line}Ver pantalla de diagnóstico de células en la placa electrónica.{new_line}Célula defectuosa a reemplazar.',
    german:
      'Auf der "Cell Test"-Platine.{new_line}Reinigung der Sicherheitsvorrichtungen.{new_line}Betrieb der Sicherheitsvorrichtungen ...{new_line}Siehe Zellendiagnosebildschirm auf der Elektronikplatine.{new_line}Defekte Zelle muss ersetzt werden.',
  },
  encoder_error_or_encoder_disconnected: {
    french: 'Contrôle encodeur (FDC)',
    english: 'Encoder check (FDC)',
    spanish: 'Comprobación del codificador (FDC)',
    german: 'Encoder-Prüfung (FDC)',
  },
  encoder_error_or_encoder_disconnected_action: {
    french:
      'Sur la carte "Verify encoder".{new_line}Connectique du fin de course éléectronique.{new_line}Positionnement encodeur et aimant.{new_line}Encodeur HS à remplacer.',
    english:
      'On the "Verify encoder" board.{new_line}Electronic limit switch connector.{new_line}Positioning encoder and magnet.{new_line}Defective encoder to be replaced.',
    spanish:
      'En la placa "Verify encoder".{new_line}Conector del interruptor de límite electrónico.{new_line}Posicionamiento del codificador y el imán.{new_line}Codificador defectuoso a reemplazar.',
    german:
      'Auf der "Verify encoder"-Platine.{new_line}Elektronischer Endschalteranschluss.{new_line}Positionierung von Encoder und Magnet.{new_line}Defekter Encoder muss ersetzt werden.',
  },
  engine_configuration_problem_or_connection_problem: {
    french: 'Contrôle motorisation',
    english: 'Motorization check',
    spanish: 'Comprobación de la motorización',
    german: 'Motorisierungsprüfung',
  },
  engine_configuration_problem_or_connection_problem_action: {
    french:
      "Sur la carte \"Verify Motor\".{new_line}Couper l'alimentation de la porte et la redémarrer sans l'arrêt d'urgence enclenché.{new_line}Paramétrage de la référence moteur - Consulter SAV.{new_line}Vérification câblage et couplage moteur.{new_line}Vérification état du câble.{new_line}Moteur à remplacer.",
    english:
      'On the "Verify Motor" board.{new_line}Cut off the power supply of the door and restart it without the emergency stop engaged.{new_line}Motor reference setting - Consult after-sales service.{new_line}Check wiring and motor coupling.{new_line}Check cable condition.{new_line}Motor to be replaced.',
    spanish:
      'En la placa "Verify Motor".{new_line}Corte el suministro de energía de la puerta y reiníciela sin que se active el paro de emergencia.{new_line}Ajuste de referencia del motor - Consultar servicio postventa.{new_line}Comprobar el cableado y el acoplamiento del motor.{new_line}Comprobar el estado del cable.{new_line}Motor a reemplazar.',
    german:
      'Auf der "Verify Motor"-Platine.{new_line}Schalten Sie die Stromversorgung der Tür ab und starten Sie sie neu, ohne den Not-Aus-Schalter zu betätigen.{new_line}Motoreinstellungsreferenz - Kundendienst konsultieren.{new_line}Überprüfen Sie die Verkabelung und die Motorkupplung.{new_line}Überprüfen Sie den Kabelzustand.{new_line}Motor muss ersetzt werden.',
  },
  igbt_electronic_temperature_problem: {
    french: 'Gestion IGBT (circuit de puissance)',
    english: 'IGBT management (power circuit)',
    spanish: 'Gestión IGBT (circuito de potencia)',
    german: 'IGBT-Management (Leistungsschaltkreis)',
  },
  igbt_electronic_temperature_problem_action: {
    french:
      'Sur la carte "Over temp".{new_line}Surchauffe lié à une utilisation intensive anormale ou sur intensité dans le circuit.{new_line}Contrôler la température du local et de l\'environnement.',
    english:
      'On the "Over temp" board.{new_line}Overheating related to abnormal intensive use or overcurrent in the circuit.{new_line}Check the temperature of the room and the environment.',
    spanish:
      'En la placa "Over temp".{new_line}Sobrecalentamiento relacionado con un uso intensivo anormal o sobrecorriente en el circuito.{new_line}Compruebe la temperatura de la habitación y el entorno.',
    german:
      'Auf der "Over temp"-Platine.{new_line}Überhitzung im Zusammenhang mit abnormal intensiver Nutzung oder Überstrom im Stromkreis.{new_line}Überprüfen Sie die Temperatur des Raums und der Umgebung.',
  },
  problem_card_configation: {
    french: 'Configuration carte',
    english: 'Card configuration problem',
    spanish: 'Problema de configuración de la tarjeta',
    german: 'Kartenkonfigurationsproblem',
  },
  problem_card_configuration_action: {
    french:
      'Sur la carte "Door not Install".{new_line}Reprendre l\'apprentissage des fin de courses.{new_line}Si Bad config: incopatibilité de programmation, réinjecter le programme.',
    english:
      'On the "Door not Install" board.{new_line}Resume the learning of the limit switches.{new_line}If Bad config: programming incompatibility, re-inject the program.',
    spanish:
      'En la placa "Door not Install".{new_line}Reanudar el aprendizaje de los interruptores de límite.{new_line}Si mala configuración: incompatibilidad de programación, reinyectar el programa.',
    german:
      'Auf der "Door not Install"-Platine.{new_line}Setzen Sie das Lernen der Endschalter fort.{new_line}Bei schlechter Konfiguration: Programminkompatibilität, Programm neu injizieren.',
  },
  lack_of_braking_resistance: {
    french: 'Résistance de freinage',
    english: 'Braking resistor',
    spanish: 'Resistencia de frenado',
    german: 'Bremswiderstand',
  },
  lack_of_braking_resistance_action: {
    french:
      'Sur la carte "Brake resistor".{new_line}Contrôle de sa présence dans l\'armoire.{new_line}Si résistance HS, à remplacer.',
    english:
      'On the "Brake resistor" board.{new_line}Check its presence in the cabinet.{new_line}If defective resistor, replace it.',
    spanish:
      'En la placa "Brake resistor".{new_line}Compruebe su presencia en el armario.{new_line}Si la resistencia es defectuosa, reemplácela.',
    german:
      'Auf der "Brake resistor"-Platine.{new_line}Überprüfen Sie dessen Vorhandensein im Schrank.{new_line}Bei defektem Widerstand ersetzen.',
  },
  emergency_stop: {
    french: "Arrêt d'urgence",
    english: 'Emergency stop',
    spanish: 'Parada de emergencia',
    german: 'Not-Aus',
  },
  emergency_stop_action: {
    french:
      "Sur la carte \"Emergency stop\".{new_line}Déverrouiller l'arrêt d'urgence.{new_line}Pour les armoires intégrées: vérifier le shunt sur l'entrée AU.{new_line}Si option clé à clé vérifier la présence de la clé à cliquet.",
    english:
      'On the "Emergency stop" board.{new_line}Unlock the emergency stop.{new_line}For integrated cabinets: check the shunt on the ES input.{new_line}If key-to-key option, check for the presence of the ratchet key.',
    spanish:
      'En la placa "Emergency stop".{new_line}Desbloquee la parada de emergencia.{new_line}Para armarios integrados: compruebe el puente en la entrada ES.{new_line}Si la opción de llave a llave, compruebe la presencia de la llave de trinquete.',
    german:
      'Auf der "Emergency stop"-Platine.{new_line}Entriegeln Sie den Not-Aus-Schalter.{new_line}Bei integrierten Schränken: Überprüfen Sie den Shunt am ES-Eingang.{new_line}Bei Schlüssel-zu-Schlüssel-Option überprüfen Sie das Vorhandensein des Ratschen-Schlüssels.',
  },
  stop_button: {
    french: 'Stop Clavier sensitif',
    english: 'Stop Sensitive keypad',
    spanish: 'Detener teclado sensible',
    german: 'Stopp Sensortastatur',
  },
  stop_button_action: {
    french:
      'Appuyer sur le bouton Stop pour remettre en service.{new_line}Si problème persistant remplacer le claver sensitif + limande (bouton bloqué).',
    english:
      'Press the Stop button to resume service.{new_line}If the problem persists, replace the sensitive keypad + magnet (stuck button).',
    spanish:
      'Presione el botón Detener para reanudar el servicio.{new_line}Si el problema persiste, reemplace el teclado sensible + imán (botón atascado).',
    german:
      'Drücken Sie die Stopp-Taste, um den Dienst wieder aufzunehmen.{new_line}Wenn das Problem weiterhin besteht, ersetzen Sie die Sensortastatur + Magnet (festsitzende Taste).',
  },
  auto_manu: {
    french: 'Fonctionnement Automatique',
    english: 'Automatic operation',
    spanish: 'Funcionamiento automático',
    german: 'Automatischer Betrieb',
  },
  auto_manu_action: {
    french: 'Sur la carte "Mode Manual".{new_line}Confirmer le fonctionnement souhaité.',
    english: 'On the "Mode Manual" board.{new_line}Confirm the desired operation.',
    spanish: 'En la placa "Mode Manual".{new_line}Confirme el funcionamiento deseado.',
    german: 'Auf der "Mode Manual"-Platine.{new_line}Bestätigen Sie den gewünschten Betrieb.',
  },
  contacteur_fbk_fault: {
    french: 'Auto-test contacteurs',
    english: 'Self-test contactors',
    spanish: 'Autoprueba de contactores',
    german: 'Selbsttest Schütze',
  },
  contacteur_fbk_fault_action: {
    french:
      'Sur la carte "Fbk Contactor".{new_line}Vérifier le cablage des contacteurs.{new_line}Contacteurs HS à remplacer.',
    english:
      'On the "Fbk Contactor" board.{new_line}Check the wiring of the contactors.{new_line}Defective contactors to be replaced.',
    spanish:
      'En la placa "Fbk Contactor".{new_line}Compruebe el cableado de los contactores.{new_line}Contactores defectuosos a reemplazar.',
    german:
      'Auf der "Fbk Contactor"-Platine.{new_line}Überprüfen Sie die Verkabelung der Schütze.{new_line}Defekte Schütze müssen ersetzt werden.',
  },
  //
  //
  //

  door_cycles_warning: {
    french: 'Avertissement cycles porte',
    english: 'Door cycles warning',
    spanish: 'Advertencia de ciclos de puerta',
    german: 'Türzyklus-Warnung',
  },
  door_cycles_warning_action: {
    french: 'Le nombre de cycles a dépassé le seuil d’alerte. Prévoir la maintenance.',
    english:
      'The number of cycles has exceeded the alert threshold. Maintenance should be planned.',
    spanish:
      'El número de ciclos ha superado el umbral de alerta. Se debe planificar el mantenimiento.',
    german:
      'Die Anzahl der Zyklen hat den Alarmgrenzwert überschritten. Wartung sollte eingeplant werden.',
  },

  unknown_category: {
    french: 'Catégorie inconnue',
    english: 'Unknown category',
    spanish: 'Categoría desconocida',
    german: 'Unbekannte Kategorie',
  },
  'ME.???': {
    french: 'Erreur mécanique inconnue',
    english: 'Unknown mechanical error',
    spanish: 'Error mecánico desconocido',
    german: 'Unbekannter mechanischer Fehler',
  },
  door_cycles_over_time: {
    french: 'Nombres de cycles par {word}',
    english: 'Number of cycles over {word}',
    spanish: 'Número de ciclos por {word}',
    german: 'Anzahl der Zyklen pro {word}',
  },
  door_time_open_over_time: {
    french: "Temps d'ouverture par {word}",
    english: 'Time open over {word}',
    spanish: 'Tiempo abierto por {word}',
    german: 'Offenzeit pro {word}',
  },
  activate_notifications_alerts: {
    french: 'Activez les notifications alertes',
    english: 'Activate alert notifications',
    spanish: 'Active las notificaciones de alertas',
    german: 'Aktivieren Sie Benachrichtigungswarnungen',
  },
  activate_notifications_anomalies: {
    french: 'Activez les notifications anomalies',
    english: 'Activate anomaly notifications',
    spanish: 'Active las notificaciones de anomalías',
    german: 'Aktivieren Sie Anomalie-Benachrichtigungen',
  },
  activate_notifications_by_email: {
    french: 'Activez les notifications par email',
    english: 'Activate email notifications',
    spanish: 'Active las notificaciones por correo electrónico',
    german: 'Aktivieren Sie E-Mail-Benachrichtigungen',
  },
  receive_red_notifications: {
    french: 'Recevoir une notification si un message rouge arrive sur une porte',
    english: 'Receive a notification if a red message arrives on a door',
    spanish: 'Recibir una notificación si llega un mensaje rojo a una puerta',
    german: 'Benachrichtigung erhalten, wenn eine rote Nachricht an eine Tür ankommt',
  },
  receive_yellow_notifications: {
    french: 'Recevoir une notification si un message orange arrive sur une porte',
    english: 'Receive a notification if an orange message arrives on a door',
    spanish: 'Recibir una notificación si llega un mensaje naranja a una puerta',
    german: 'Benachrichtigung erhalten, wenn eine orange Nachricht an eine Tür ankommt',
  },
  receive_notifications_by_email: {
    french: 'Recevoir les notifications par email (1 email par heure maximum)',
    english: 'Receive notifications by email (1 email per hour maximum)',
    spanish:
      'Recibir notificaciones por correo electrónico (1 correo electrónico por hora como máximo)',
    german: 'Benachrichtigungen per E-Mail erhalten (maximal 1 E-Mail pro Stunde)',
  },
  mark_all_as_read: {
    french: 'Tout marquer comme lu',
    english: 'Mark all as read',
    spanish: 'Marcar todo como leído',
    german: 'Alle als gelesen markieren',
  },
  load_more: {
    french: 'Charger plus',
    english: 'Load more',
    spanish: 'Cargar más',
    german: 'Mehr laden',
  },
  no_notifications: {
    french: 'Aucune notification',
    english: 'No notifications',
    spanish: 'No hay notificaciones',
    german: 'Keine Benachrichtigungen',
  },
  no_recommendations: {
    french: 'Aucune recommandation',
    english: 'No recommendations',
    spanish: 'No hay recomendaciones',
    german: 'Keine Empfehlungen',
  },
  door_cycles_warning_recommendation: {
    french: 'Seuil dépassé : {threshold}{new_line}Nombre de cycles : {doorCycles}',
    english: 'Threshold exceeded: {threshold}{new_line}Number of cycles: {doorCycles}',
    spanish: 'Umbral superado: {threshold}{new_line}Número de ciclos: {doorCycles}',
    german: 'Schwellenwert überschritten: {threshold}{new_line}Anzahl der Zyklen: {doorCycles}',
  },
  collaborator_added: {
    french: 'Le collaborateur a été ajouté avec succès !',
    english: 'Collaborator added successfully!',
    spanish: '¡Colaborador agregado con éxito!',
    german: 'Mitarbeiter erfolgreich hinzugefügt!',
  },
  collaborator_removed: {
    french: 'Le collaborateur a été supprimé avec succès !',
    english: 'Collaborator removed successfully!',
    spanish: '¡Colaborador eliminado con éxito!',
    german: 'Mitarbeiter erfolgreich entfernt!',
  },
  chart_max_value: {
    french: 'Max :',
    english: 'Max:',
    spanish: 'Máx.:',
    german: 'Max:',
  },
  never: {
    french: 'Jamais',
    english: 'Never',
    spanish: 'Nunca',
    german: 'Niemals',
  },
  monthly: {
    french: 'Mensuel',
    english: 'Monthly',
    spanish: 'Mensual',
    german: 'Monatlich',
  },
  weekly: {
    french: 'Hebdomadaire',
    english: 'Weekly',
    spanish: 'Semanal',
    german: 'Wöchentlich',
  },
  daily: {
    french: 'Quotidien',
    english: 'Daily',
    spanish: 'Diario',
    german: 'Täglich',
  },
  hourly: {
    french: 'Heure par heure',
    english: 'Hourly',
    spanish: 'Cada hora',
    german: 'Stündlich',
  },
  notifications: {
    french: 'Notifications',
    english: 'Notifications',
    spanish: 'Notificaciones',
    german: 'Benachrichtigungen',
  },
  faq: {
    french: 'FAQ',
    english: 'FAQ',
    spanish: 'Preguntas frecuentes',
    german: 'FAQ',
  },
  history_messages: {
    french: 'Historique des messages',
    english: 'Message History',
    spanish: 'Historial de mensajes',
    german: 'Nachrichtenverlauf',
  },
  share_incident: {
    french: "Partager l'incident",
    english: 'Share the incident',
    spanish: 'Compartir el incidente',
    german: 'Teilen Sie den Vorfall',
  },
  recommendations: {
    french: 'Recommandations',
    english: 'Recommendations',
    spanish: 'Recomendaciones',
    german: 'Empfehlungen',
  },
  want_to_send_email: {
    french: 'Voulez-vous envoyer ce message ?',
    english: 'Do you want to send this message?',
    spanish: '¿Quieres enviar este mensaje?',
    german: 'Möchten Sie diese Nachricht senden?',
  },
  send_to: {
    french: 'Envoyer à',
    english: 'Send to',
    spanish: 'Enviar a',
    german: 'Senden an',
  },
  height: {
    french: 'Hauteur :',
    english: 'Height:',
    spanish: 'Altura:',
    german: 'Höhe:',
  },
  no_height: {
    french: 'Pas de hauteur',
    english: 'No height',
    spanish: 'Sin altura',
    german: 'Keine Höhe',
  },
  height_ht: {
    french: 'Hauteur HT :',
    english: 'Overall height:',
    spanish: 'Altura total:',
    german: 'Gesamte Höhe:',
  },
  no_height_ht: {
    french: 'Pas de hauteur HT',
    english: 'No overall height',
    spanish: 'Sin altura total',
    german: 'Keine Gesamthöhe',
  },
  width: {
    french: 'Largeur :',
    english: 'Width:',
    spanish: 'Ancho:',
    german: 'Breite:',
  },
  no_width: {
    french: 'Pas de largeur',
    english: 'No width',
    spanish: 'Sin ancho',
    german: 'Keine Breite',
  },
  width_ht: {
    french: 'Largeur HT :',
    english: 'Overall width:',
    spanish: 'Ancho total:',
    german: 'Gesamte Breite:',
  },
  no_width_ht: {
    french: 'Pas de largeur HT',
    english: 'No overall width',
    spanish: 'Sin ancho total',
    german: 'Keine Gesamtbreeite',
  },
  no_custom_address: {
    french: 'Non renseigné',
    english: 'Not provided',
    spanish: 'No proporcionado',
    german: 'Nicht angegeben',
  },
  file_uploaded_successfully: {
    french: 'Fichier téléchargé avec succès !',
    english: 'File uploaded successfully!',
    spanish: '¡Archivo subido con éxito!',
    german: 'Datei erfolgreich hochgeladen!',
  },
  error_uploading_file: {
    french: 'Erreur lors du téléchargement du fichier, veuillez réessayer.',
    english: 'Error uploading file, please try again.',
    spanish: 'Error al subir el archivo, por favor intente de nuevo.',
    german: 'Fehler beim Hochladen der Datei, bitte versuchen Sie es erneut.',
  },
  file_deleted_successfully: {
    french: 'Fichier supprimé avec succès !',
    english: 'File deleted successfully!',
    spanish: '¡Archivo eliminado con éxito!',
    german: 'Datei erfolgreich gelöscht!',
  },
  error_deleting_file: {
    french: 'Erreur lors de la suppression du fichier, veuillez réessayer.',
    english: 'Error deleting file, please try again.',
    spanish: 'Error al eliminar el archivo, por favor intente de nuevo.',
    german: 'Fehler beim Löschen der Datei, bitte versuchen Sie es erneut.',
  },
  error_fetching_file: {
    french: 'Erreur lors de la récupération du fichier :',
    english: 'Error fetching file:',
    spanish: 'Error al obtener el archivo:',
    german: 'Fehler beim Abrufen der Datei:',
  },
  preview_image: {
    french: "Aperçu de l'image",
    english: 'Image preview',
    spanish: 'Vista previa de la imagen',
    german: 'Bildvorschau',
  },
  enable_notifications_for_this_door: {
    french: 'Activer les notifications pour cette porte',
    english: 'Enable notifications for this door',
    spanish: 'Habilitar notificaciones para esta puerta',
    german: 'Benachrichtigungen für diese Tür aktivieren',
  },
  notifications_activated: {
    french: 'Notifications activées',
    english: 'Notifications activated',
    spanish: 'Notificaciones activadas',
    german: 'Benachrichtigungen aktiviert',
  },
  notifications_deactivated: {
    french: 'Notifications désactivées',
    english: 'Notifications deactivated',
    spanish: 'Notificaciones desactivadas',
    german: 'Benachrichtigungen deaktiviert',
  },
  apply: {
    french: 'Appliquer',
    english: 'Apply',
    spanish: 'Aplicar',
    german: 'Anwenden',
  },
  choose_door_id: {
    french: 'Choisir un ID de porte',
    english: 'Choose a door ID',
    spanish: 'Elija una identificación de puerta',
    german: 'Wählen Sie eine Tür-ID',
  },
  choose_counter: {
    french: 'Choisir un compteur',
    english: 'Choose a counter',
    spanish: 'Elija un contador',
    german: 'Wählen Sie einen Zähler',
  },
  only_show_alerts_anomalies: {
    french: "N'afficher que les alertes et anomalies",
    english: 'Only show alerts and anomalies',
    spanish: 'Mostrar solo alertas y anomalías',
    german: 'Nur Warnungen und Anomalien anzeigen',
  },

  welcome_to_the_app: {
    french: "Bienvenue sur l'application",
    english: 'Welcome to the application',
    spanish: 'Bienvenido a la aplicación',
    german: 'Willkommen in der Anwendung',
  },
  add_your_comment_here: {
    french: 'Ajoutez votre commentaire ici...',
    english: 'Add your comment here...',
    spanish: 'Agrega tu comentario aquí...',
    german: 'Fügen Sie hier Ihren Kommentar hinzu...',
  },
  parent_group: {
    french: 'Groupe parent :',
    english: 'Parent group:',
    spanish: 'Grupo principal:',
    german: 'Elterngruppe:',
  },
  add_a_label: {
    french: 'Ajouter une identification',
    english: 'Add an identification',
    spanish: 'Agregar una identificación',
    german: 'Identifikation hinzufügen',
  },
  specifications: {
    french: 'Spécifications :',
    english: 'Specifications:',
    spanish: 'Especificaciones:',
    german: 'Spezifikationen:',
  },
  no_specifications: {
    french: 'Aucune spécification',
    english: 'No specifications',
    spanish: 'Sin especificaciones',
    german: 'Keine Spezifikationen',
  },

  curtain_color: {
    french: 'Couleur tablier :',
    english: 'Curtain color:',
    spanish: 'Color del tablero:',
    german: 'Farbe des Tabliers:',
  },
  no_curtain_color: {
    french: 'Pas de couleur tablier',
    english: 'No curtain color',
    spanish: 'Sin color del tablero',
    german: 'Keine Farbe des Tabliers',
  },

  classification: {
    french: 'Classification :',
    english: 'Classification:',
    spanish: 'Clasificación:',
    german: 'Klassifikation:',
  },
  no_classification: {
    french: 'Pas de classification',
    english: 'No classification',
    spanish: 'Sin clasificación',
    german: 'Keine Klassifikation',
  },

  structure_color: {
    french: 'Structure :',
    english: 'Structure:',
    spanish: 'Estructura:',
    german: 'Struktur:',
  },
  no_structure_color: {
    french: 'Pas de couleur structure',
    english: 'No structure color',
    spanish: 'Sin color de la estructura',
    german: 'Keine Farbe der Struktur',
  },

  voltage: {
    french: 'Tension :',
    english: 'Voltage:',
    spanish: 'Tensión:',
    german: 'Spannung:',
  },
  no_voltage: {
    french: 'Pas de tension',
    english: 'No voltage',
    spanish: 'Sin tensión',
    german: 'Keine Spannung',
  },

  cabinet: {
    french: 'Armoire :',
    english: 'Cabinet:',
    spanish: 'Armario:',
    german: 'Schrank:',
  },
  no_cabinet: {
    french: "Pas d'armoire",
    english: 'No cabinet',
    spanish: 'Sin armario',
    german: 'Kein Schrank',
  },

  label: {
    french: 'Label :',
    english: 'Label:',
    spanish: 'Etiqueta:',
    german: 'Etikett:',
  },
  notification_settings_updated: {
    french: 'Paramètres de notification mis à jour avec succès !',
    english: 'Notification settings updated successfully!',
    spanish: '¡Configuración de notificaciones actualizada con éxito!',
    german: 'Benachrichtigungseinstellungen erfolgreich aktualisiert!',
  },
  error_saving_notification_settings: {
    french: 'Erreur lors de la sauvegarde des paramètres de notification.',
    english: 'Error saving notification settings.',
    spanish: 'Error al guardar la configuración de notificaciones.',
    german: 'Fehler beim Speichern der Benachrichtigungseinstellungen.',
  },
  status_change_not_allowed: {
    french: "Le changement de statut n'est pas autorisé pour cette catégorie.",
    english: 'Status change not allowed for this category.',
    spanish: 'Cambio de estado no permitido para esta categoría.',
    german: 'Statusänderung für diese Kategorie nicht erlaubt.',
  },
  leave_the_group: {
    french: 'Quitter le groupe',
    english: 'Leave the group',
    spanish: 'Dejar el grupo',
    german: 'Gruppe verlassen',
  },
  confirm_leave_group: {
    french: 'Êtes-vous sûr de vouloir quitter ce groupe ?',
    english: 'Are you sure you want to leave this group?',
    spanish: '¿Está seguro de que desea dejar este grupo?',
    german: 'Sind Sie sicher, dass Sie diese Gruppe verlassen möchten?',
  },
  sav: {
    french: 'SAV',
    english: 'Support',
    spanish: 'Soporte',
    german: 'Support',
  },
  back_to_search: {
    french: 'Retour à la recherche',
    english: 'Back to search',
    spanish: 'Volver a la búsqueda',
    german: 'Zurück zur Suche',
  },
  cycle_numbers: {
    french: 'Nombre de cycles :',
    english: 'Cycle count:',
    spanish: 'Conteo de ciclos:',
    german: 'Zählung der Zyklen:',
  },
  loading: {
    french: 'Chargement...',
    english: 'Loading...',
    spanish: 'Cargando...',
    german: 'Wird geladen...',
  },

  email_sent_successfully: {
    french: 'Email envoyé avec succès !',
    english: 'Email sent successfully!',
    spanish: '¡Correo electrónico enviado con éxito!',
    german: 'E-Mail erfolgreich gesendet!',
  },
  failed_to_send_email: {
    french: "Échec de l'envoi de l'email.",
    english: 'Failed to send email.',
    spanish: 'No se pudo enviar el correo electrónico.',
    german: 'E-Mail konnte nicht gesendet werden.',
  },
  please_add_comments: {
    french: 'Veuillez ajouter des commentaires.',
    english: 'Please add comments.',
    spanish: 'Por favor agregue comentarios.',
    german: 'Bitte fügen Sie Kommentare hinzu.',
  },
  please_add_media: {
    french: 'Veuillez ajouter des médias.',
    english: 'Please add media.',
    spanish: 'Por favor agregue medios.',
    german: 'Bitte fügen Sie Medien hinzu.',
  },
  powered_by: {
    french: 'Développé par',
    english: 'Powered by',
    spanish: 'Desarrollado por',
    german: 'Entwickelt von',
  },
  add_a_custom_group: {
    french: 'Ajouter un groupe personnalisé',
    english: 'Add a custom group',
    spanish: 'Agregar un grupo personalizado',
    german: 'Fügen Sie eine benutzerdefinierte Gruppe hinzu',
  },
  custom_group_name: {
    french: 'Nom du groupe personnalisé',
    english: 'Custom group name',
    spanish: 'Nombre del grupo personalizado',
    german: 'Name der benutzerdefinierten Gruppe',
  },
  custom_group_created: {
    french: 'Groupe personnalisé créé avec succès !',
    english: 'Custom group created successfully!',
    spanish: '¡Grupo personalizado creado con éxito!',
    german: 'Benutzerdefinierte Gruppe erfolgreich erstellt!',
  },
  error_create_custom_group: {
    french: 'Erreur lors de la création du groupe personnalisé.',
    english: 'Error creating custom group.',
    spanish: 'Error al crear el grupo personalizado.',
    german: 'Fehler beim Erstellen der benutzerdefinierten Gruppe.',
  },
  no_custom_group_available: {
    french: 'Aucun groupe personnalisé disponible',
    english: 'No custom group available',
    spanish: 'No hay grupo personalizado disponible',
    german: 'Keine benutzerdefinierte Gruppe verfügbar',
  },
  add: {
    french: 'Ajouter',
    english: 'Add',
    spanish: 'Agregar',
    german: 'Hinzufügen',
  },
  add_door_to_custom_group: {
    french: 'Ajouter la porte au groupe personnalisé',
    english: 'Add door to custom group',
    spanish: 'Agregar puerta al grupo personalizado',
    german: 'Tür zur benutzerdefinierten Gruppe hinzufügen',
  },
  remove_door_from_this_custom_group: {
    french: 'Retirer la porte de ce groupe personnalisé',
    english: 'Remove door from this custom group',
    spanish: 'Eliminar puerta de este grupo personalizado',
    german: 'Tür aus dieser benutzerdefinierten Gruppe entfernen',
  },
  door_added_to_custom_group: {
    french: 'Porte ajoutée au groupe personnalisé avec succès !',
    english: 'Door added to custom group successfully!',
    spanish: '¡Puerta agregada al grupo personalizado con éxito!',
    german: 'Tür erfolgreich zur benutzerdefinierten Gruppe hinzugefügt!',
  },
  door_removed_from_custom_group: {
    french: 'Porte retirée du groupe personnalisé avec succès !',
    english: 'Door removed from custom group successfully!',
    spanish: '¡Puerta eliminada del grupo personalizado con éxito!',
    german: 'Tür erfolgreich aus der benutzerdefinierten Gruppe entfernt!',
  },
  please_select_a_valid_group: {
    french: 'Veuillez sélectionner un groupe valide.',
    english: 'Please select a valid group.',
    spanish: 'Por favor seleccione un grupo válido.',
    german: 'Bitte wählen Sie eine gültige Gruppe aus.',
  },
  door_cycles: {
    french: 'Nombre de cycles',
    english: 'Number of cycles',
    spanish: 'Número de ciclos',
    german: 'Anzahl der Zyklen',
  },
  door_time_open: {
    french: "Durée d'ouverture",
    english: 'Time open',
    spanish: 'Tiempo abierto',
    german: 'Offenzeit',
  },
  door_inversion_button: {
    french: 'Bouton inversion',
    english: 'Inversion button',
    spanish: 'Botón de inversión',
    german: 'Inversionsknopf',
  },
  door_inversion_cell: {
    french: 'Inversion cellule',
    english: 'Inversion cell',
    spanish: 'Inversión de celda',
    german: 'Inversionszelle',
  },
  door_inversion_impact: {
    french: 'Impact inversion',
    english: 'Inversion impact',
    spanish: 'Impacto de inversión',
    german: 'Inversionsschlag',
  },
  cell_dirty: {
    french: 'Cellule sale',
    english: 'Dirty cell',
    spanish: 'Celda sucia',
    german: 'Verschmutzte Zelle',
  },
  door_close: {
    french: 'Fermeture porte',
    english: 'Door close',
    spanish: 'Cierre de puerta',
    german: 'Tür schließen',
  },
  door_open: {
    french: 'Ouverture porte',
    english: 'Door open',
    spanish: 'Apertura de puerta',
    german: 'Tür öffnen',
  },
  counter_IC0: {
    french: 'Compteur IC0',
    english: 'IC0 counter',
    spanish: 'Contador IC0',
    german: 'IC0-Zähler',
  },
  counter_IC1: {
    french: 'Compteur IC1',
    english: 'IC1 counter',
    spanish: 'Contador IC1',
    german: 'IC1-Zähler',
  },
  counter_I5: {
    french: 'Compteur I5',
    english: 'I5 counter',
    spanish: 'Contador I5',
    german: 'I5-Zähler',
  },
  door_state_view_title: {
    french: 'Dernier état enregistré',
    english: 'Last recorded state',
    spanish: 'Último estado registrado',
    german: 'Letzter aufgezeichneter Zustand',
  },
  remove_the_group: {
    french: 'Supprimer le groupe',
    english: 'Remove the group',
    spanish: 'Eliminar el grupo',
    german: 'Gruppe entfernen',
  },
  update_the_name: {
    french: 'Mettre à jour le nom',
    english: 'Update the name',
    spanish: 'Actualizar el nombre',
    german: 'Aktualisieren Sie den Namen',
  },
  group_name_updated: {
    french: 'Nom du groupe mis à jour avec succès !',
    english: 'Group name updated successfully!',
    spanish: '¡Nombre del grupo actualizado con éxito!',
    german: 'Gruppenname erfolgreich aktualisiert!',
  },
  group_name_placeholder: {
    french: 'Entrez le nouveau nom',
    english: 'Enter the new name',
    spanish: 'Ingrese el nuevo nombre',
    german: 'Geben Sie den neuen Namen ein',
  },
  logout_warning: {
    french: 'Êtes-vous sûr de vouloir vous déconnecter ?',
    english: 'Are you sure you want to log out?',
    spanish: '¿Está seguro de que desea cerrar sesión?',
    german: 'Sind Sie sicher, dass Sie sich abmelden möchten?',
  },
  select_group: {
    french: 'Sélectionner un groupe',
    english: 'Select a group',
    spanish: 'Seleccionar un grupo',
    german: 'Wählen Sie eine Gruppe aus',
  },
  activate_support_app: {
    french: 'Activer le mode avancé (SAV)',
    english: 'Activate advanced mode',
    spanish: 'Activar modo avanzado',
    german: 'Erweiterten Modus aktivieren',
  },
  error_updating_account: {
    french: 'Erreur lors de la mise à jour du compte.',
    english: 'Error updating account.',
    spanish: 'Error al actualizar la cuenta.',
    german: 'Fehler beim Aktualisieren des Kontos.',
  },
  delivered_by_maviflex_at_address: {
    french: 'Livré par Maviflex à :',
    english: 'Delivered by Maviflex at:',
    spanish: 'Entregado por Maviflex en:',
    german: 'Von Maviflex an:',
  },
  door_custom_address: {
    french: 'Adresse de la porte :',
    english: 'Door address:',
    spanish: 'Dirección de la puerta:',
    german: 'Türaddresse:',
  },
  door_custom_address_updated: {
    french: "L'adresse personnalisée de la porte a été mise à jour avec succès !",
    english: 'Door custom address updated successfully!',
    spanish: '¡Dirección personalizada de la puerta actualizada con éxito!',
    german: 'Benutzerdefinierte Türadresse erfolgreich aktualisiert!',
  },
  error_updating_door_custom_address: {
    french:
      "Erreur lors de la mise à jour de l'adresse personnalisée de la porte, veuillez réessayer.",
    english: 'Error updating door custom address, please try again.',
    spanish:
      'Error al actualizar la dirección personalizada de la puerta, por favor intente de nuevo.',
    german:
      'Fehler beim Aktualisieren der benutzerdefinierten Türadresse, bitte versuchen Sie es erneut.',
  },
  support_messages_title: {
    french: 'SAV messages',
    english: 'Messages support',
    german: 'Supportnachrichten',
    spanish: 'Mensajes de soporte',
  },
  date_and_time_joiner: {
    french: ' à ',
    english: ' at ',
    spanish: ' a las ',
    german: ' um ',
  },
  hour_to_hour: {
    french: 'à',
    english: 'to',
    spanish: 'a',
    german: 'um',
  },
  door_details__door_members: {
    french: 'Emails ayant accès à la porte',
    english: 'Emails having access to the door',
    spanish: 'Emails con acceso a la puerta',
    german: 'E-Mails mit Zugang zur Tür',
  },
  door_details__door_groups: {
    french: 'Groupes de la porte',
    english: 'Door groups',
    spanish: 'Grupos de la puerta',
    german: 'Türgruppen',
  },
  // <SEARCH_FIELDS>
  search_field__id: {
    french: 'ID',
    english: 'ID',
    spanish: 'ID',
    german: 'ID',
  },
  search_field__name1: {
    french: 'Nom 1',
    english: 'Name 1',
    spanish: 'Nombre 1',
    german: 'Name 1',
  },
  search_field__name2: {
    french: 'Nom 2',
    english: 'Name 2',
    spanish: 'Nombre 2',
    german: 'Name 2',
  },
  search_field__name3: {
    french: 'Nom 3',
    english: 'Name 3',
    spanish: 'Nombre 3',
    german: 'Name 3',
  },
  search_field__customerName: {
    french: 'Nom du client',
    english: 'Customer name',
    spanish: 'Nombre del cliente',
    german: 'Kundenname',
  },
  search_field__customAddress: {
    french: 'Adresse personnalisée',
    english: 'Custom address',
    spanish: 'Dirección personalizada',
    german: 'Benutzerdefinierte Adresse',
  },
  search_field__address1: {
    french: 'Adresse ligne 1',
    english: 'Address line 1',
    spanish: 'Línea de dirección 1',
    german: 'Adresszeile 1',
  },
  search_field__address2: {
    french: 'Adresse ligne 2',
    english: 'Address line 2',
    spanish: 'Línea de dirección 2',
    german: 'Adresszeile 2',
  },
  search_field__address3: {
    french: 'Adresse ligne 3',
    english: 'Address line 3',
    spanish: 'Línea de dirección 3',
    german: 'Adresszeile 3',
  },
  search_field__postalCode: {
    french: 'Code postal',
    english: 'Postal code',
    spanish: 'Código postal',
    german: 'Postleitzahl',
  },
  search_field__city: {
    french: 'Ville',
    english: 'City',
    spanish: 'Ciudad',
    german: 'Stadt',
  },
  search_field__country: {
    french: 'Pays',
    english: 'Country',
    spanish: 'País',
    german: 'Land',
  },
  // </SEARCH_FIELDS>
  no_doors_search_results: {
    french: 'Aucune des portes ne correspond',
    english: 'None of the door matches',
    spanish: 'Ninguna de las puertas coincide',
    german: 'Keine der Türen passt',
  },
  search_form_button_loading_placeholder: {
    french: 'Chargement des portes...',
    english: 'Loading doors...',
    spanish: 'Cargando puertas...',
    german: 'Türen werden geladen...',
  },
  search_form_button: {
    french: 'Rechercher',
    english: 'Search',
    spanish: 'Buscar',
    german: 'Suchen',
  },
  // <DOOR_DETAILS>
  contact: {
    french: 'Contact',
    english: 'Contact',
    spanish: 'Contacto',
    german: 'Kontakt',
  },
  contacts: {
    french: 'Contacts',
    english: 'Contacts',
    spanish: 'Contactos',
    german: 'Kontakte',
  },
  door_buyer: {
    french: 'Commandeur',
    english: 'Buyer',
    spanish: 'Comprador',
    german: 'Käufer',
  },
  door_buyer_and_maintainer: {
    french: 'Commandeur et maintenancier',
    english: 'Buyer and maintainer',
    spanish: 'Comprador y mantenimiento',
    german: 'Käufer und Wartungspersonal',
  },
  door_buyer_and_maintainer_and_customer: {
    french: 'Commandeur, maintenancier et utilisateur',
    english: 'Buyer, maintainer and user',
    spanish: 'Comprador, mantenimiento y usuario',
    german: 'Käufer, Wartungspersonal und Nutzer',
  },
  door_buyer_and_customer: {
    french: 'Commandeur et utilisateur',
    english: 'Buyer and user',
    spanish: 'Comprador y usuario',
    german: 'Käufer und Nutzer',
  },
  door_maintainer: {
    french: 'Maintenancier',
    english: 'Maintainer',
    spanish: 'Mantenimiento',
    german: 'Wartungspersonal',
  },
  door_maintainer_and_customer: {
    french: 'Maintenancier et utilisateur',
    english: 'Maintainer and user',
    spanish: 'Mantenimiento y usuario',
    german: 'Wartungspersonal und Nutzer',
  },
  door_customer: {
    french: 'Utilisateur',
    english: 'User',
    spanish: 'Usuario',
    german: 'Nutzer',
  },
  // </DOOR_DETAILS>
  total: {
    french: 'Total :',
    english: 'Total:',
    spanish: 'Total:',
    german: 'Insgesamt:',
  },
};
